<script>
import ImageTile from '@/components/ImageTile'
import LoadingBar from '@/components/LoadingBar'

export default
{
    name: 'loyalty-card-store-balance-card',

    props:
    {
        store: { type: Object, required: true },
        storeConfig: { type: Object, required: true },
        balance: { type: Object, required: true },
    },

    created ()
    {
    },

    render () 
    {
        return (
            <image-tile class='loyalty-card-store-balance-card' title={this.store.name} background-image={this.store.pictures[0]}
                on-click={() => this.$emit('click')}>
                <loading-bar progress={this.balance.points/this.storeConfig.maxBalance} />
                <div class='points-summup'><b>{this.balance.points}</b> points sur <b>{this.storeConfig.maxBalance}</b></div>
            </image-tile>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
        ImageTile,
        LoadingBar
    }
}
</script>

<style lang='less'>
.loyalty-card-store-balance-card
{
    .points-summup
    {
        font-size: 12px;
        margin-top: 5px;
        color: var(--theme-text-color-extra-light);

        b
        {
            color: inherit;
            font-weight: bold;
        }
    }

    .loading-bar
    {
        margin-top: 10px;

        .foreground
        {
            background-color: rgba(255,255,255,0.6);
            }

        .background
        {
            background-color: var(--theme-text-color-light);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LoyaltyCardStoreBalanceCard.vue